module.exports = __webpack_public_path__ + "8758dcfedf421078b5d84ff1490280c1.svg";